import style from "../AboutUs/AboutUs.module.css";

const Privacy = () => {
  return (
    <div className={style["aboutus-container"]}>
      <h2>PRIVACY POLICY - CONECTAR</h2>
      <p>
        At Conectar, we prioritize the privacy and security of your personal
        information. This Privacy Policy explains how we collect, use, disclose,
        and protect the information you provide while using our website as an
        escrow service between service providers and recipients.
      </p>
      <h4>Information we collect:</h4>

      <p>
        <span>Personal Information:</span> When you register as a user on
        Conectar, we may collect personal information such as your name, email
        address, permanent address, residential address, contact number, billing
        details, and government issued identification documents. This
        information is necessary for us to facilitate transactions and provide
        our services.
      </p>
      <p>
        <span>Transaction Information:</span> To ensure a secure escrow process,
        we collect transaction-related details such as the service requested,
        the agreed-upon price, and any additional terms and conditions.
      </p>
      <p>
        <span>Communication Information: </span>We may collect information
        related to your communication with us, including messages, inquiries,
        and feedback.
      </p>
      <h4>How We Use Your Information:</h4>

      <p>
        <span>Facilitating Transactions: </span>We use your personal information
        and transaction details to facilitate the escrow process between service
        providers and recipients, ensuring secure and transparent transactions.
      </p>
      <p>
        <span>Communication: </span>We may use your contact information to
        communicate with you regarding transaction updates, service-related
        inquiries, and other relevant information.
      </p>
      <p>
        <span>Improving Our Services: </span>We may analyze aggregated and
        anonymized data to improve our website, services, and user experience.
      </p>
      <h4>Information Sharing:</h4>

      <p>
        <span>Service Providers and Recipients: </span>As an escrow service, we
        share relevant information between the involved service providers and
        recipients to facilitate the transaction process.
      </p>
      <p>
        <span>Legal Compliance: </span>We may disclose your information if
        required by law or in response to a valid legal request, such as a court
        order or government inquiry.
      </p>
      <h4>Data Retention:</h4>

      <p>
        We retain your personal information for as long as necessary to fulfill
        the purposes outlined in this Privacy Policy unless a longer retention
        period is required or permitted by law. We will securely dispose of or
        anonymize your information when it is no longer needed.
      </p>
      <h4>Cookies and Similar Technologies:</h4>

      <p>
        We may use cookies and similar technologies to enhance your browsing
        experience, analyze usage patterns, and personalize content. By using
        Conectar, you consent to the use of cookies in accordance with this
        Privacy Policy and our Cookie Policy.
      </p>
      <h4>Your Rights:</h4>

      <p>
        <span>Access and Correction: </span>You have the right to contact us
        directly if the need arise to access, review, update, or correct any of
        the information you provided upon signing up on this website.
      </p>
      <p>
        <span>Data Portability: </span>You may request a copy of your personal
        information in a structured, commonly used, and machine-readable format.
      </p>
      <p>
        <span>Withdrawal of Consent: </span>You have the right to withdraw your
        consent to the processing of your personal information at any time by
        contacting us.
      </p>
      <p>
        <span>Erasure: </span>You can request the erasure of your personal
        information in certain circumstances, such as when it is no longer
        necessary for the purposes for which it was collected.
      </p>
      <p>
        <span>Objection: </span>You can object to the processing of your
        personal information in certain situations, such as direct marketing or
        when the processing is based on legitimate interests.
      </p>
      <p>
        <span>Restriction: </span>You have the right to request the restriction
        of the processing of your personal information in certain circumstances.
      </p>
      <h4>Data Security:</h4>

      <p>
        We implement reasonable and appropriate security measures to protect
        your personal information and ensure the confidentiality of your data.
        However, please note that no method of transmission or storage over the
        internet is completely secure, and we cannot guarantee the absolute
        security of your information.
      </p>
      <h4>Children's Privacy:</h4>

      <p>
        Conectar is not intended for use by individuals under the age of 18
        ("Children"). We do not knowingly collect personal information from
        Children. If you are a parent or guardian and you become aware that your
        Child has provided us with personal information, please contact us. If
        we become aware that we have collected personal information from
        Children without verification of parental consent, we will take steps to
        remove that information from our servers.
      </p>
      <h4>Transfers:</h4>

      <p>
        As Conectar operates only within Nigeria, your personal information may
        be transferred to and processed in countries outside of your residence.
        These countries may have different data protection laws than your own.
        By using Conectar and providing your information, you consent to such
        transfers.
      </p>
      <h4>Changes to the Privacy Policy: </h4>

      <p>
        We reserve the right to update or modify this Privacy Policy at any
        time. Any changes will be posted on our website, and the revised policy
        will apply to all information collected after the updated policy is
        posted. We encourage you to review this Privacy Policy periodically for
        any updates or changes.
      </p>
      <h4>Contact Us:</h4>

      <p>
        If you have any questions or concerns about this Privacy Policy or our
        data practices, please contact us at [insert contact details(email and
        phone numbers)].
      </p>
    </div>
  );
};

export default Privacy;
